"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const notistack_1 = require("notistack");
const material_ui_confirm_1 = require("material-ui-confirm");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const CompletePreviewButtons_1 = require("../CompletePreviewButtons");
const _1 = require(".");
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const roomData = (0, react_redux_1.useSelector)((state) => state.roomData);
    const { id: roomId, title: roomTitle, refund_policy: refundPolicy, room_type: roomType, fee_free: isFeeFree, support_delivery_date: supportDeliveryDate, } = roomData;
    const isRegularForm = roomType === '굿즈' || roomType === '서포트';
    const isPromiseForm = isRegularForm && isFeeFree;
    const regularSales = (0, react_redux_1.useSelector)((state) => state.regularSales);
    const deliveryType = (0, react_redux_1.useSelector)((state) => state.deliveryType);
    const freeDeliveries = (0, react_redux_1.useSelector)((state) => state.freeDeliveries);
    const fixedDeliveries = (0, react_redux_1.useSelector)((state) => state.fixedDeliveries);
    const additionalDeliveries = (0, react_redux_1.useSelector)((state) => state.additionalDeliveries);
    const conditionalDeliveries = (0, react_redux_1.useSelector)((state) => state.conditionalDeliveries);
    const diffDeliveries = (0, react_redux_1.useSelector)((state) => state.diffDeliveries);
    const customDeliveries = (0, react_redux_1.useSelector)((state) => state.customDeliveries);
    const delete_deliveries = (0, react_redux_1.useSelector)((state) => state.delete_deliveries);
    const originProductData = (0, react_redux_1.useSelector)((state) => state.originProductData);
    const productData = (0, react_redux_1.useSelector)((state) => state.productData);
    const keepingRefundPolicy = (0, react_redux_1.useSelector)((state) => state.keepingRefundPolicy);
    const originRefundPolicy = (0, react_redux_1.useSelector)((state) => state.originRefundPolicy);
    const { is_question, questions } = roomData;
    const delete_questions = (0, react_redux_1.useSelector)((state) => state.delete_questions);
    const generateErrors = () => {
        let errors = [];
        const titleError = (0, CompletePreviewButtons_1.validateRoomTitle)({ roomTitle });
        if (titleError)
            errors.unshift(titleError);
        const supportDeliveryDateError = (0, CompletePreviewButtons_1.validateSupportDeliveryDate)({
            supportDeliveryDate,
            regularSales,
        });
        if (supportDeliveryDateError)
            errors.unshift(supportDeliveryDateError);
        const productError = (0, CompletePreviewButtons_1.validateProductData)({ productData });
        if (productError)
            errors.unshift(productError);
        if (keepingRefundPolicy) {
            const refundPolicyError = (0, CompletePreviewButtons_1.validateRefundPolicy)(refundPolicy);
            if (refundPolicyError)
                errors.unshift(refundPolicyError);
        }
        return errors;
    };
    const generateUpdates = () => {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, (0, CompletePreviewButtons_1.generateRoomData)({ roomData, isTempSave: true })), (0, CompletePreviewButtons_1.generateDeliveryData)({
            deliveryType,
            freeDeliveries,
            fixedDeliveries,
            additionalDeliveries,
            conditionalDeliveries,
            diffDeliveries,
            customDeliveries,
            delete_deliveries,
        })), { 
            // ? "products: undefined" will be removed automatically by Axios during the serialization process
            products: (0, CompletePreviewButtons_1.generateProductData)({ originProductData, productData, isPromiseForm }), refund_policy: (0, CompletePreviewButtons_1.generateRefundPolicy)(refundPolicy) }), (0, CompletePreviewButtons_1.generateQuestionData)({ is_question, questions, delete_questions }));
    };
    const [tempData, setTempData] = (0, react_1.useState)([]);
    const getTempList = () => __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.getData)(`/api/v1/room/temp`).then((res) => __awaiter(this, void 0, void 0, function* () {
            if (res.status === 200) {
                setTempData(res.data.result);
            }
        }));
    });
    const [tempModalOpen, setTempModalOpen] = (0, react_1.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const saveTempData = () => __awaiter(this, void 0, void 0, function* () {
        setIsSubmitting(true);
        let tempListCount = 0;
        let overwriteFlag = false;
        const errorsArr = generateErrors();
        if (errorsArr.length) {
            errorsArr.forEach((errorMsg) => enqueueSnackbar(errorMsg, snackbarOptions));
            setIsSubmitting(false);
        }
        else {
            tempData.map((data) => {
                if (data.id == roomId) {
                    overwriteFlag = true;
                }
            });
            yield (0, api_1.getData)(`/api/v1/room/temp/count`)
                .then((res) => __awaiter(this, void 0, void 0, function* () {
                if (res.status === 200) {
                    tempListCount = res.data.result.temp_count;
                    const updates = generateUpdates();
                    if (tempListCount < 5 || overwriteFlag) {
                        yield (0, CompletePreviewButtons_1.saveRefundPolicy)({ keepingRefundPolicy, refundPolicy, originRefundPolicy })
                            .then(() => __awaiter(this, void 0, void 0, function* () {
                            yield (0, api_1.patchData)(`/api/v1/store/room/${roomId}`, updates).then((res) => __awaiter(this, void 0, void 0, function* () {
                                if (res.status === 200) {
                                    window.onbeforeunload = null;
                                    yield getTempList();
                                    (0, functions_1.showToastMessage)({ message: t('임시저장 완료되었어요') });
                                    dispatch((0, roomCreateStore_1.getRoomData)(`${roomId}`));
                                }
                            }));
                        }))
                            .catch(() => {
                            confirm({
                                description: (0, errors_1.commonErrorMsg)(),
                                cancellationButtonProps: { style: { display: 'none' } },
                            });
                        });
                    }
                    else {
                        const openModal = () => setTempModalOpen(true);
                        confirm({
                            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('임시저장은 최대 5개까지 저장할 수 있어요.'), (0, jsx_runtime_1.jsx)("br", {}), t('기존 내역을 삭제하시겠어요?')] })),
                            confirmationText: t('삭제하러 가기'),
                        })
                            .then(openModal)
                            .catch(() => { });
                    }
                }
            }))
                .catch(() => {
                confirm({
                    description: (0, errors_1.commonErrorMsg)(),
                    cancellationButtonProps: { style: { display: 'none' } },
                });
            })
                .finally(() => {
                setTimeout(() => setIsSubmitting(false), 1000);
            });
        }
    });
    const { enqueueSnackbar, closeSnackbar } = (0, notistack_1.useSnackbar)();
    const snackbarOptions = {
        variant: 'warning',
        autoHideDuration: 99999,
        onClick: () => closeSnackbar(),
    };
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    position: maxWidth768 ? 'absolute' : 'static',
                    right: '11px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: maxWidth768 ? '98px' : '100%',
                    height: maxWidth768 ? '32px' : '40px',
                    borderRadius: maxWidth768 ? '6px' : '8px',
                    border: '1px solid var(--gray-10)',
                    '> button': {
                        height: '100%',
                        color: 'var(--gray-80)',
                        backgroundColor: 'var(--white) !important',
                    },
                    '> button:first-of-type': {
                        flex: 1,
                        justifyContent: 'flex-end',
                        paddingRight: maxWidth768 ? '8px' : '12px',
                        borderRadius: maxWidth768 ? '6px 0 0 6px' : '8px 0 0 8px',
                    },
                    '> button:last-of-type': {
                        width: '68px',
                        '@media (max-width: 768px)': { width: '28px' },
                        '@media (min-width: 769px) and (max-width: 1080px)': { width: '60px' },
                        justifyContent: 'flex-start',
                        paddingLeft: maxWidth768 ? '8px' : '12px',
                        borderRadius: maxWidth768 ? '0 6px 6px 0' : '0 8px 8px 0',
                    },
                } }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: () => {
                            saveTempData();
                        }, disabled: isSubmitting }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: `${maxWidth768 ? 'caption1' : 'body2'} gray-80` }, { children: t('임시저장') })) })), (0, jsx_runtime_1.jsx)("span", { css: {
                            height: '12px',
                            borderRight: '1px solid var(--table-row)',
                        } }), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: () => {
                            setTempModalOpen(true);
                        } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle4 primary-dark" }, { children: tempData.length })) }))] })), (0, jsx_runtime_1.jsx)(_1.TempSaveModal, { tempModalOpen: tempModalOpen, setTempModalOpen: setTempModalOpen, tempData: tempData, setTempData: setTempData })] }));
}
exports.default = default_1;
